import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { SERVICES } from "../../data/services";
import { Field, TextInput, inputCls } from "./Field";
import { SubmitButton, SuccessPanel } from "./SubmitButton";

const empty = (service) => ({ full_name: "", company_name: "", email: "", phone: "", service: service || "", headcount: "", location: "", message: "" });

export const EnquiryForm = ({ defaultService }) => {
  const [form, setForm] = useState(empty(defaultService));
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/enquiries", form);
      setDone(true);
      toast.success("Enquiry sent. Our team will contact you shortly.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return <SuccessPanel testId="enquiry-success" title="Thank you." text="Your enquiry has reached our team. We will get back to you with next steps."
      onReset={() => { setForm(empty(defaultService)); setDone(false); }} />;
  }

  return (
    <form onSubmit={submit} className="grid gap-x-8 gap-y-8 sm:grid-cols-2" data-testid="enquiry-form">
      <TextInput id="enquiry-name" label="Full name" required value={form.full_name} onChange={set("full_name")} placeholder="Your name" />
      <TextInput id="enquiry-company" label="Company" value={form.company_name} onChange={set("company_name")} placeholder="Company name" />
      <TextInput id="enquiry-email" label="Email" type="email" required value={form.email} onChange={set("email")} placeholder="you@company.com" />
      <TextInput id="enquiry-phone" label="Phone" type="tel" required value={form.phone} onChange={set("phone")} placeholder="+91" />
      <Field id="enquiry-service" label="Service required" required>
        <select id="enquiry-service" required value={form.service} onChange={set("service")} className={`${inputCls} [&>option]:bg-[var(--ink)]`} data-testid="enquiry-service-select">
          <option value="" disabled>Select a service</option>
          {SERVICES.map((s) => <option key={s.slug} value={s.title}>{s.title}</option>)}
          <option value="Multiple services">Multiple services</option>
        </select>
      </Field>
      <TextInput id="enquiry-headcount" label="Headcount / volume" value={form.headcount} onChange={set("headcount")} placeholder="e.g. 20 staff, 50,000 pages" />
      <TextInput id="enquiry-location" label="Site location" className="sm:col-span-2" value={form.location} onChange={set("location")} placeholder="City / site address" />
      <Field id="enquiry-message" label="Requirement details" className="sm:col-span-2">
        <textarea id="enquiry-message" rows={4} value={form.message} onChange={set("message")} className={`${inputCls} resize-none`}
          placeholder="Shifts, start date, scope…" data-testid="enquiry-message-input" />
      </Field>
      <div className="sm:col-span-2">
        <SubmitButton loading={loading} testId="enquiry-submit-button">Send enquiry</SubmitButton>
      </div>
    </form>
  );
};
